import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import SessionStyles from '../../styles/Session';
import { withRouter } from 'react-router-dom';
import Logo from './Artboard.png';
import DesktopBackground from './Desktop.png';
import client from './../../utils/apolloClient';
import gql from 'graphql-tag';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import getData, { sendOTP, login, verify, SignInAPI } from './../../data-services/api';
import InputBase from '@material-ui/core/InputBase';

const messages = {
    phoneno: {
        shouldMatchRegex: 'Phone number is not valid',
        UserNotExist: 'Sorry, we don’t have any User with this Mobile Number',
        isRequired: 'Mobile No. Required',
    },
};

const PhoneNumberSubmitForm = ({
    classes,
    handleChange,
    handleSubmit,
    touched,
    errors,
    values,
    ...props
}) => {
    return (
        <Fragment>
            <form onSubmit={handleSubmit}>
                <Grid container justify="flex-start" style={{ marginLeft: -6 }}>
                    <Grid item xs={12}>
                        <FormControl
                            style={{
                                borderRadius: '36px',
                                display: 'inline-block',
                                overflow: 'hidden',
                                background: '#fff',
                                marginLeft: '-1px',
                                padding: '2px 10px',
                                border: '1px solid #cccccc',
                            }}
                            fullWidth
                            className={classes.formControl}
                        >
                            <Select
                                name="role"
                                native
                                value={values.role}
                                onChange={handleChange}
                                fullWidth={true}
                                disableUnderline
                            >
                                <option value={'FCP'}>FCP</option>
                                <option value={'CMDI'}>CMDI</option>
                                <option value={'AMMD'}>AMMD</option>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {/* <TextField
            name="phoneno"
            variant="outlined"
            label="Enter Mobile Number"
            className={classes.textField}
            fullWidth
            onChange={handleChange}
            value={values.phoneno}
            value={values.phoneno}
            error={errors.phoneno && touched.phoneno}
            FormHelperTextProps={{
              error: errors.phoneno && touched.phoneno
            }}
            helperText={
              errors.phoneno && touched.phoneno ? errors.phoneno : null
            }
            autocomplete="off"
          /> */}
                        <InputBase
                            name="phoneno"
                            variant="outlined"
                            label="Enter Mobile Number"
                            className={classes.textField}
                            fullWidth
                            placeholder="Enter Mobile Number"
                            onChange={handleChange}
                            value={values.phoneno}
                            error={errors.phoneno && touched.phoneno}
                            FormHelperTextProps={{
                                error: errors.phoneno && touched.phoneno,
                            }}
                            helperText={errors.phoneno && touched.phoneno ? errors.phoneno : null}
                            autocomplete="off"
                            style={{
                                backgroundColor: 'white',
                                borderRadius: 25,
                                padding: '2px 10px',
                                letterSpacing: '-1px',
                            }}
                        />
                    </Grid>
                    {/* <Grid item xs={2}>
            <Button
              size="small"
              style={{
                marginLeft: "15px"
              }}
              type="submit"
              className={classes.button}
            >
              <Icon
                align="center"
                className={classes.rightIcon}
                style={{ fontSize: 28 }}
                color="secondary"
              >
                send
            </Icon>
            </Button>
          </Grid> */}
                    <Grid item xs={12}>
                        <Typography
                            variant="subtitle1"
                            style={{
                                color: 'red',
                                fontSize: '10px',
                            }}
                            gutterBottom
                        >
                            {errors.phoneno && touched.phoneno ? errors.phoneno : null}
                        </Typography>
                    </Grid>
                    <Grid xs={12}>
                        <InputBase
                            name="password"
                            variant="outlined"
                            label="Enter Password"
                            className={classes.textField}
                            fullWidth
                            type="password"
                            placeholder="Enter Password"
                            onChange={handleChange}
                            value={values.password}
                            error={errors.password && touched.password}
                            FormHelperTextProps={{
                                error: errors.password && touched.password,
                            }}
                            helperText={
                                errors.password && touched.password ? errors.password : null
                            }
                            autocomplete="off"
                            style={{
                                backgroundColor: 'white',
                                borderRadius: 25,
                                marginTop: '5px',
                                padding: '2px 10px',
                                letterSpacing: '-1px',
                            }}
                        />
                    </Grid>
                </Grid>
                <a href="/#" role="button" onClick={() => props.handleForgetPassword()}>
                    <Typography
                        align="left"
                        variant="subheading"
                        color="secondary"
                        style={{
                            marginTop: '2px',
                        }}
                    >
                        Forget Password? &nbsp;
                    </Typography>
                </a>
                <br />
                <Grid container justify="center" spacing={8}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            fullWidth
                            type="submit"
                            style={{ borderRadius: 25 }}
                            color="secondary"
                            // onClick={props.handleSignin(values.role, values.phoneno, values.password)}
                            className={classes.button}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Fragment>
    );
};

const phoneRegExp = /^( )*[0-9]{10}( )*/;

const formHandler = withFormik({
    // Set Default Values for fields
    mapPropsToValues: (props) => ({
        phoneno: '',
        role: localStorage.getItem('role') ? localStorage.getItem('role') : 'FCP',
    }),
    // Add validation to fields
    validationSchema: Yup.object().shape({
        // name: Yup.string("Should be string").required("Name required"),
        // website: Yup.string("Should be string").required("Website required"),
        role: Yup.string('Should be String').oneOf(
            ['FCP', 'CMDI', 'AMMD'],
            'Should be one of CMDI, FCP, AMMD'
        ),
        phoneno: Yup.string()
            .matches(phoneRegExp, messages.phoneno.shouldMatchRegex)
            .required(messages.phoneno.isRequired),
    }),
    // Submit Form
    handleSubmit: async (values, { props, setSubmitting, setFieldError, ...otherOptions }) => {
        setSubmitting(true);
        localStorage.setItem('role', values.role);
        try {
            await props.handleSignin(values);
        } catch (e) {
            if (e === 'UserNotExist') {
                setFieldError('phoneno', messages.phoneno.UserNotExist);
            }
        }
        setSubmitting(false);
    },
});

const formStyles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
});

export const PhoneNumberSubmitFormFinal = formHandler(
    withStyles(formStyles)(PhoneNumberSubmitForm)
);

class Signin extends Component {
    state = {
        phonenoSubmit: false,
        otpError: null,
    };

    // not in use for otp login
    signInHandler = async () => {
        // if (false) {
        // if()
        if (
            // this.state.role !== 'FCP' &&
            parseInt(this.state.sentOtp) !== parseInt(this.state.otp)
        ) {
            this.setState({
                otpError: 'Invalid OTP',
            });
        } else {
            /// temp arrangement while otp is not enabled on backend

            const onVerify = await verify({
                otp: 1234,
                phoneNumber: this.state.phoneno,
                role: this.state.role,
            });
            if (onVerify.token) {
                const { role, phoneno } = this.state;

                localStorage.setItem('token', onVerify.token);
                localStorage.setItem('tokenSetAt', new Date().toISOString());

                const { result: data } =
                    role === 'AMMD' || role === 'CMDI'
                        ? await getData(`
                Select Id, SFId, Type__c, Reporting_To_AMMD__c, Name, Email__c, Login_Mobile_Number__c as phone 
                from salesforce.Pidilite_User__c 
                where Login_Mobile_Number__c = '${phoneno}' 
                  and type__c='${role}'`)
                        : await getData(`
                Select Id, SFId, Name, Email__c, Phone, Assigned_CMDI__c 
                from salesforce.Account 
                where Phone = '${phoneno}' 
                  And RecordTypeId='${process.env.REACT_APP_FCP_RECORD_TYPE_ID}'`);

                if (!data || data.length === 0) {
                    throw new Error('User does not exist');
                }

                client
                    .mutate({
                        mutation: gql`
        mutation SignIn{
          login(phoneno:${data[0].phone} role:${this.state.role})@client{
                status
                user{
                  role
                  id
                  status
                }
            }
        }`,
                    })
                    .then(({ data }) => {
                        if (data.login.status) {
                            switch (data.login.user.role) {
                                case 'FCP':
                                    this.props.history.replace('/newHomeFCP');
                                    break;
                                case 'CMDI':
                                    this.props.history.replace('/homeCMDI');
                                    break;
                                case 'AMMD':
                                    this.props.history.replace('/homeAMMD');
                                    break;
                                default:
                                    console.warn(`Unhandled role: ${data.login.user.role}`);
                                    break;
                            }
                        }
                    });
            } else {
                this.setState({
                    otpError: 'Invalid OTP',
                });
            }
        }
    };

    // in use for password login
    signInHandler2 = async (values) => {
        const onVerify = await SignInAPI({
            phoneNumber: values.phoneno,
            userType: values.role,
            password: values.password,
        });

        if (onVerify.token) {
            const { role, phoneno } = values;

            localStorage.setItem('token', onVerify.token);
            localStorage.setItem('tokenSetAt', new Date().toISOString());

            const { result: data } =
                role === 'AMMD' || role === 'CMDI'
                    ? await getData(`
                    Select Id, SFId, Type__c, Reporting_To_AMMD__c, Name, Email__c, Login_Mobile_Number__c as phone 
                    from salesforce.Pidilite_User__c 
                    where Login_Mobile_Number__c = '${phoneno}' 
                      and type__c='${role}'`)
                    : await getData(`
                    Select Id, SFId, Name, Email__c, Phone, Assigned_CMDI__c 
                    from salesforce.Account 
                    where Phone = '${phoneno}' 
                      And RecordTypeId='${process.env.REACT_APP_FCP_RECORD_TYPE_ID}'`);

            if (!data || data.length === 0) {
                throw new Error('User does not exist');
            }

            try {
                const response = await client.mutate({
                    mutation: gql`
                    mutation SignIn{
                      login(phoneno: ${data[0].phone} role: ${values.role}) @client {
                        status
                        user {
                          role
                          id
                          status
                        }
                      }
                    }
                `,
                });

                if (response.data.login.status) {
                    switch (response.data.login.user.role) {
                        case 'FCP':
                            this.props.history.replace('/newHomeFCP');
                            break;
                        case 'CMDI':
                            this.props.history.replace('/homeCMDI');
                            break;
                        case 'AMMD':
                            this.props.history.replace('/homeAMMD');
                            break;
                        default:
                            console.warn('Unhandled user role:', response.data.login.user.role);
                    }
                }
            } catch (e) {
                console.log('Error:', e);
            }
        } else {
            this.setState({ otpError: 'Invalid Credentials!' });
        }
    };

    handlePhoneSubmit = async ({ phoneno, role }) => {
        try {
            const data = await login({
                phoneNumber: phoneno,
                userType: role,
            });

            if (!data || data.result === 'Not registered') {
                throw new Error('UserNotExist'); // Use Error object
            }

            // Generate a 4-digit OTP
            const otp = Math.floor(Math.random() * 9000) + 1000;

            const newPhoneno = phoneno.trim();

            await sendOTP(otp, newPhoneno);

            this.setState({
                phoneno: newPhoneno,
                phonenoSubmit: true,
                role,
                sentOtp: otp,
            });
        } catch (error) {
            console.error('Error in handlePhoneSubmit:', error);
            throw error; // or handle error state here
        }
    };

    resendOtp = async () => {
        const otp = Math.floor(Math.random() * 980) + 1000;
        await sendOTP(otp, this.state.userData.phone);
        this.setState({
            sentOtp: otp,
        });
    };

    render() {
        const { classes } = this.props;
        const { otpError } = this.state;
        return (
            <Fragment>
                <div
                    className={classNames(classes.session)}
                    style={{
                        backgroundImage: `url(${DesktopBackground})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: '100% 100%',
                    }}
                >
                    <div className={classes.content}>
                        <div className={classes.wrapper}>
                            <Card
                                elevation={0}
                                style={{
                                    padding: 20,
                                    background: 'transparent',
                                }}
                            >
                                <CardContent>
                                    <div className="text-xs-center pb-xs">
                                        <img src={Logo} alt="logo" style={{ height: 100 }} />
                                    </div>
                                    <Typography
                                        style={{
                                            color: 'white',
                                        }}
                                        align="center"
                                        variant="title"
                                    >
                                        LOGIN
                                    </Typography>
                                    {/* {!phonenoSubmit ? ( */}
                                    <PhoneNumberSubmitFormFinal
                                        handleSignin={this.signInHandler2}
                                        handlePhoneSubmit={this.handlePhoneSubmit}
                                        handleForgetPassword={() =>
                                            this.props.history.replace('/ForgetPassword')
                                        }
                                    />
                                    {otpError ? (
                                        <Typography
                                            variant="subtitle1"
                                            style={{
                                                color: 'red',
                                                fontSize: '10px',
                                            }}
                                            gutterBottom
                                        >
                                            {otpError}
                                        </Typography>
                                    ) : null}
                                    {/* ) : (
                      <Fragment>
                        <Typography
                          align="left"
                          variant="caption"
                          style={{ marginTop: 10, color: "white" }}
                        >
                          Please enter the OTP sent to your Mobile Number
                      </Typography>
                        <InputBase
                          id="otp"
                          label="Enter OTP "
                          className={classes.textField}
                          type="password"
                          name="otp"
                          margin="normal"
                          fullWidth
                          onChange={e => {
                            this.setState({
                              [e.target.name]: e.target.value
                            });
                          }}
                          style={{
                            backgroundColor: "white",
                            borderRadius: 25,
                            padding: "2px 10px",
                            letterSpacing: "-1px",
                            marginTop: "10px"
                          }}
                          value={otp}
                        />
                        {otpError ?
                          <Typography
                            variant="subtitle1"
                            style={{
                              color: "red",
                              fontSize: "10px"
                            }}
                            gutterBottom
                          >
                            {otpError}
                          </Typography>
                          : null}

                        <a onClick={this.resendOtp}>
                          <Typography
                            align="right"
                            variant="subheading"
                            color="secondary"
                            style={{
                              marginTop: "2px"
                            }}
                          >
                            Resend OTP  &nbsp;
                          </Typography>
                        </a>
                        <br />
                        <Grid container justify="center" spacing={8}>
                          <Grid item xs={12}>
                            <Button
                              variant="contained"
                              fullWidth
                              style={{ borderRadius: 25 }}
                              color="secondary"
                              onClick={this.signInHandler}
                              className={classes.button}
                            >
                              Submit
                            </Button>
                          </Grid>
                        </Grid>
                      </Fragment>
                    )} */}
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Signin.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(SessionStyles)(Signin));
